import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-heating-circuit-ignored-modal',
  templateUrl: './heating-circuit-ignored-modal.component.html',
  styleUrls: ['./heating-circuit-ignored-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeatingCircuitIgnoredModalComponent {
  askAgain = false;

  constructor(
    public dialogRef: MatDialogRef<HeatingCircuitIgnoredModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onChange(askAgain: boolean): void {
    if (this.data.doNotAskAgain) {
      const localStorageLabel = 'doNotAskAgainModalIsIgnored';
      localStorage.setItem(localStorageLabel, (!askAgain).toString());
    }
  }

  onConfirm(): void {
    this.dialogRef.close({ action: 'close' });
  }

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}
